import { useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { helpContentState, helpFixState, openHelpState } from "../recoil";
import { t } from "i18next";

interface HelpWindowProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function HelpWindow({ isOpen, onClose }: HelpWindowProps) {
  const [externalWindow, setExternalWindow] = useState<Window | null>(null);
  const helpContent = useRecoilValue(helpContentState);
  const setHelpFix = useSetRecoilState(helpFixState);
  const setOpenHelp = useSetRecoilState(openHelpState);

  useEffect(() => {
    if (isOpen && !externalWindow) {
      const width = 300;
      const height = 400;
      const left = window.screen.width / 2 - width / 2;
      const top = window.screen.height / 2 - height / 2;

      const newWindow = window.open(
        "",
        "helpWindow",
        `width=${width},height=${height},left=${left},top=${top},resizable=yes`
      );

      if (newWindow) {
        setExternalWindow(newWindow);

        const messageHandler = (event: MessageEvent) => {
          if (event.data === "handleFix") {
            setHelpFix((prev) => !prev);
            setExternalWindow(null);
            onClose();
          } else if (event.data === "openModal") {
            setOpenHelp(true);
            setExternalWindow(null);
            onClose();
          }
        };

        window.addEventListener("message", messageHandler);

        newWindow.onbeforeunload = () => {
          window.opener.postMessage("windowClosed", "*");
          setExternalWindow(null);
          onClose();
        };
        return () => {
          window.removeEventListener("message", messageHandler);
          if (newWindow && !newWindow.closed) {
            newWindow.close();
          }
          setExternalWindow(null);
        };
      }
    }
  }, [isOpen]);

  useEffect(() => {
    if (externalWindow && !externalWindow.closed) {
      externalWindow.document.write(`
        <html>
          <head>
            <title>${t("Help")}</title>
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
            <style>
              body { font-family: Arial, sans-serif; margin: 0; padding: 20px; }
              .header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
              .content { line-height: 1.5; }
              button { 
                padding: 5px 10px; 
                cursor: pointer;
                margin-left: 8px;
              }
            </style>
          </head>
          <body>
            <div class="header">
              <h5>${t("Help")}</h2>
              <div>
                <button onclick="handlePin()" title="고정">
                  <span class="material-icons">push_pin</span>
                </button>
                <button onclick="openModal()" title="모달로 전환">
                  <span class="material-icons">open_in_browser</span>
                </button>
              </div>
            </div>
            <div class="content" styles={{color:"var(--text-color)"}}>
              ${helpContent}
            </div>
            <script>
              function handlePin() {
                window.opener.postMessage('handleFix', '*');
              }
              function openModal() {
                window.opener.postMessage('openModal', '*');
              }
            </script>
          </body>
        </html>
      `);
      externalWindow.document.close();
    }
  }, [helpContent, externalWindow]);

  return null;
}
